import { enterKeyDownHandler } from '../../utils/enterKeyDownHandler';
import { AulaPlugin } from '../plugins';
import { EditorState } from '../../Editor.types';

let isComposing = false; // IME Composing going on
let hasCompositionJustEnded = false; // Used to swallow keyup event related to compositionend

export const handleReturn: (
  onSend?: (editorState: EditorState) => void
) => AulaPlugin = (onSend) => (editableProps, editor, context) => {
  if (!context) {
    throw new Error('context needs to be initialized');
  }
  return {
    ...editableProps,
    onKeyDown: (event) => {
      if (editableProps.onKeyDown) editableProps.onKeyDown(event);
      if (event.key === 'Enter') {
        // Prevent to trigger the onChange flow when pressing the enter key
        event.preventDefault();
        if (!event.shiftKey) {
          // IME composing fires keydown/keyup events
          if (isComposing || hasCompositionJustEnded) {
            hasCompositionJustEnded = false;
            return;
          }
          if (typeof onSend === 'function') {
            onSend({
              context: { entities: context.entities },
              value: editor.children,
            });
            return;
          }
        }
        enterKeyDownHandler(event, editor);
      }
    },
    onCompositionStart: () => {
      isComposing = true;
    },
    onCompositionEnd: () => {
      isComposing = false;
      // some browsers (IE, Firefox, Safari) send a keyup event after
      // compositionend, some (Chrome, Edge) don't. This is to swallow
      // the next keyup event, unless a keydown event happens first
      hasCompositionJustEnded = true;
    },
  };
};
